import { SVG } from 'components/Asset/SVG';
import { FlexBox } from 'components/Containers/FlexBox';
import { MediumText } from 'components/Typography/MediumText';
import { type CSSProperties } from 'react';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

type HeaderIconStyle = CSSProperties & {
  '--info-tooltip-color'?: string;
};

interface Props {
  headerName: string;
  iconName: string;
}

/*
    Note, this only renders the tooltip icon, not the tooltip itself.
    To render tooltip in AG grid headers, use the headerTooltip: 'Tooltip Text'
    property in columnDefs
*/
export const WithIconHeader = ({ headerName, iconName }: Props) => {
  const infoIconColor =
    CLIENT_THEME === 'yokohama'
      ? clientThemePalette.yokohama.light.primary
      : undefined;
  const iconStyle: HeaderIconStyle = {
    paddingLeft: '5px',
    alignSelf: 'center',
    ...(infoIconColor ? { '--info-tooltip-color': infoIconColor } : {}),
  };

  return (
    <FlexBox>
      <MediumText text={headerName} />
      <SVG name={iconName} style={iconStyle} />
    </FlexBox>
  );
};
